import React, { useState } from "react";
import LearnTabs from "@/components/home/LearnTabs";

const FIELDS = [
  { key: "erfahrung", label: "Erfahrungsnote (Schule)", w: 0.2 },
  { key: "praktisch", label: "Praktische Arbeit (VPA/IPA)", w: 0.4 },
  { key: "berufskunde", label: "Berufskunde Prüfung", w: 0.2 },
  { key: "abu", label: "Allgemeinbildung (ABU)", w: 0.2 },
];

export default function NotenrechnerPage() {
  const [v, setV] = useState({ erfahrung: "5.0", praktisch: "4.5", berufskunde: "4.8", abu: "5.0" });
  const num = (k) => parseFloat(v[k]) || 0;
  const gesamt = FIELDS.reduce((a, f) => a + num(f.key) * f.w, 0);
  const bestanden = gesamt >= 4 && num("praktisch") >= 4;

  return (
    <div>
      <LearnTabs />
      <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground">QV · LAP</p>
      <h1 className="font-heading text-2xl sm:text-4xl font-extrabold">Notenrechner</h1>
      <p className="text-sm text-slate-500 font-semibold mt-1">
        Unverbindliche Schätzung mit pauschaler Gewichtung. Massgebend ist die Bildungsverordnung deines Berufs.
      </p>

      <div className="brutal bg-white border-2 border-black p-4 rounded-xl mt-5 text-black">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {FIELDS.map((f) => (
            <label key={f.key} className="block text-xs font-bold">
              {f.label}
              <input
                type="number" min="1" max="6" step="0.1" inputMode="decimal"
                value={v[f.key]}
                onChange={(e) => setV({ ...v, [f.key]: e.target.value })}
                className="w-full border-2 border-black rounded-lg px-3 py-2 font-bold mt-1 text-black bg-white"
              />
            </label>
          ))}
        </div>

        <div className={`mt-4 border-2 border-black rounded-xl p-4 flex items-center justify-between ${bestanden ? "bg-[#CAFFBF]" : "bg-[#FFADAD]"}`}>
          <div>
            <div className="text-[10px] font-bold uppercase tracking-widest text-black">Gesamtnote</div>
            <div className="text-3xl font-black text-black">{gesamt.toFixed(2)}</div>
          </div>
          <div className="text-sm font-extrabold text-black">{bestanden ? "✓ Bestanden" : "✗ Nicht bestanden"}</div>
        </div>
      </div>
    </div>
  );
}
